// extracted by mini-css-extract-plugin
export default {"loader":"buttonLoader_loader__yvGU1","spin":"buttonLoader_spin__lEc8Q"};